var HAH = HAH || {};

HAH.product = (function () {
    return {
        getPrice: function (tmpInvtID: string, type: string): number {
            let returnValue = 0;
            try {
                if (type === 'listprice') {
                    returnValue = parseFloat(itemListPrices[tmpInvtID]);
                } else {
                    returnValue = parseFloat(itemPrices[tmpInvtID]);
                }
                returnValue = Number(returnValue.toFixed(2));
            } catch (e) { }
            if (isNaN(Number(returnValue))) {
                returnValue = 0;
            }
            return returnValue;
        },
        showHideATC: function (elementIndex: number, status: string): void {
            if (status === 'out') {
                hideElement(`SPANQty${elementIndex}`);
                hideElement('quantity', elementIndex);
                hideElement('qty');
                hideElement('addToCartBtnContainer');
                document.querySelectorAll('.qty').forEach((el: HTMLElement) => el.style.visibility = 'hidden')
                hideElement('addToCartBtn');
                hideElement('addition');
                showElement('SPANstockContainer');
                showElement(`SPANstock${elementIndex}`);
            } else {
                showElement(`SPANQty${elementIndex}`);
                showElement('quantity', elementIndex, '');
                showElement('qty', 0, '');
                showElement('addToCartBtnContainer');
                showElement('addition');
                document.querySelectorAll('.qty').forEach((el: HTMLElement) => el.style.visibility = 'visible')
                showElement('addToCartBtn');
                hideElement('SPANstockContainer');
                hideElement(`SPANstock${elementIndex}`);
            }
        },
        doGetStockMessage: function (tmpItemID: string, elementIndex: number, InstockOverride: boolean): string {
            let returnValue = '';
            try {
                let stockInvtID = HAH.product.getProductID(tmpItemID, elementIndex);
                let stockMessageValues = itemStockLevel[stockInvtID].split('|');
                let stkItem = parseInt(stockMessageValues[0]);
                let qtyAvail = parseInt(stockMessageValues[1]);
                let reOrdQty = parseInt(stockMessageValues[2]);
                let reOrdQtyOverride = parseInt(stockMessageValues[3]);
                let customInStockMessage = stockMessageValues[4];
                if (stkItem === 0 || InstockOverride) {
                    //dropship items always instock
                    returnValue = (customInStockMessage === '') ? defaultInStockMessage : customInStockMessage;
                    HAH.product.showHideATC(elementIndex, 'in');
                } else {
                    if (qtyAvail <= 0) {
                        returnValue = defaultOutOfStockMessage;
                        HAH.product.showHideATC(elementIndex, 'out');
                    } else if (qtyAvail <= reOrdQtyOverride || qtyAvail <= reOrdQty) {
                        returnValue = defaultLowStockMessage;
                        HAH.product.showHideATC(elementIndex, 'in');
                    } else {
                        returnValue = (customInStockMessage === '') ? defaultInStockMessage : customInStockMessage;
                        HAH.product.showHideATC(elementIndex, 'in');
                    }
                }
            } catch (e) { }
            return returnValue;
        },
        checkAddOnStock: function (tmpItemID: string, elementIndex: number, addOnProductID: string, addOnElementIndex: number, Instock: boolean): void {
            let addOnInvID = addOnProductID;
            let addOnExtGroups = null;
            let tmpExtValue = '';
            try {
                addOnExtGroups = (<HTMLFormElement>document.getElementById('OCForm1')).productIDExtensionGroups[addOnElementIndex].value.split(';');
            } catch (e) { }
            let tmpExtGroups = (<HTMLFormElement>document.getElementById('OCForm1')).productIDExtensionGroups[elementIndex].value.split(';');
            (<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[0]}`)).selectedIndex = (<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtGroups[0]}`)).selectedIndex;
            let addOnExtensionOptionsLength = (<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[0]}`)).options.length;
            for (let k = 0; k < addOnExtensionOptionsLength; k++) {
                if ((<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[0]}`)).options[k].value == (<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtGroups[0]}`)).options[(<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtGroups[0]}`)).selectedIndex].value) {
                    (<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[0]}`)).selectedIndex = k;
                }
            }
            for (let i = 0; i < addOnExtGroups.length; i++) {
                if (addOnExtGroups[i] !== '') {
                    if ((<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[i]}`)).selectedIndex === 0) {
                        tmpExtValue = 'SELECT';
                    } else {
                        tmpExtValue = (<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[i]}`)).options[(<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[i]}`)).selectedIndex].value;
                    }
                    addOnInvID += tmpExtValue;
                }
            }
            if (tmpExtValue != 'SELECT') {
                let stockAddOnInvtID = addOnInvID;
                let stockAddOnMessageValues = itemStockLevel[stockAddOnInvtID].split('|');
                let stkItemAddOn = parseInt(stockAddOnMessageValues[0]);
                let qtyAvailAddOn = parseInt(stockAddOnMessageValues[1]);
                if ((stkItemAddOn === 0) || (Instock)) {
                    document.getElementById('addition').style.visibility = 'visible';
                } else {
                    if (qtyAvailAddOn <= 0) {
                        if ((<HTMLFormElement>document.getElementById('OCForm1')).productID[addOnElementIndex].checked) {
                            (<HTMLFormElement>document.getElementById('OCForm1')).productID[addOnElementIndex].checked = false;
                        }
                        document.getElementById('addition').style.visibility = 'hidden';
                    } else {
                        document.getElementById('addition').style.visibility = 'visible';
                    }
                }
            }
        },
        getProductID: function (tmpItemID: string, elementIndex: number): string {
            let tmpExtensions = null;
            let returnValue = tmpItemID ? tmpItemID : (<HTMLInputElement>document.getElementById('productID')).value;
            let indexValue = elementIndex ? elementIndex : 0;
            let tmpExtValue = '';
            try {
                tmpExtensions = (<HTMLFormElement>document.getElementById('OCForm1')).productIDExtensionGroups[indexValue].value.split(';');
            } catch (e) { }
            if (tmpExtensions === null) {
                tmpExtensions = (<HTMLFormElement>document.getElementById('OCForm1')).productIDExtensionGroups.value.split(';');
            }
            for (let i = 0; i < tmpExtensions.length; i++) {
                if (tmpExtensions[i] !== '') {
                    if (tmpItemID) {
                        if ((<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtensions[i]}`)).selectedIndex === 0) {
                            tmpExtValue = 'SELECT';
                        } else {
                            tmpExtValue = (<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtensions[i]}`)).options[(<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtensions[i]}`)).selectedIndex].value;
                        }
                    } else {
                        if ((<HTMLSelectElement>document.getElementById(tmpExtensions[i])).selectedIndex === 0) {
                            tmpExtValue = 'SELECT';
                        } else {
                            tmpExtValue = (<HTMLSelectElement>document.getElementById(tmpExtensions[i])).options[(<HTMLSelectElement>document.getElementById(tmpExtensions[i])).selectedIndex].value;
                        }
                    }
                    returnValue += tmpExtValue;
                }
            }
            return returnValue;
        }
    };
})();

$(document).ready(function () {
    addToCartObj.bindElementHandlers();
});
function doExtensionChange(tmpItemID: string): void {
    let groundShipIDs: Array<string>, InstockOverride: boolean, stockMessage: string, price: number, listPrice: number, addOnPrice: number, addOnListPrice: number, Instock: boolean;
    let addOnProductID = document.getElementById('addOnProductID')? (<HTMLInputElement>document.getElementById('addOnProductID')).value : '';
    let productIDs = (<HTMLFormElement>document.getElementById('OCForm1')).productID;
    let elementIndex: number, addOnElementIndex: number = 0;
    let tmpInvtID = '';
    if (productIDs.length !== undefined) {
        for (let i = 0; i < productIDs.length; i++) {
            if (productIDs[i].value === tmpItemID) {
                elementIndex = i;
            }
            if (productIDs[i].value === addOnProductID) {
                addOnElementIndex = i;
            }
        }
        groundShipIDs = (<HTMLFormElement>document.getElementById('OCForm1')).groundShipIDs.value.split(',');
        InstockOverride = false;
        Instock = false;
        if (groundShipIDs) {
            for (let j = 0; j < groundShipIDs.length; j++) {
                if (groundShipIDs[j] === tmpItemID) {
                    InstockOverride = true;
                }
                if (groundShipIDs[j] === addOnProductID) {
                    Instock = true;
                }
            }
        }
        if (classOptions.itemProps[tmpItemID].isSubs === false) {
            stockMessage = HAH.product.doGetStockMessage(tmpItemID, elementIndex, InstockOverride);
        }
        if (stockMessage !== '') {
            try {
                document.getElementById(`SPANstock${elementIndex}`).innerHTML = stockMessage;
            } catch (e) { }
        }
        tmpInvtID = HAH.product.getProductID(tmpItemID, elementIndex);
        price = HAH.product.getPrice(tmpInvtID);
        listPrice = HAH.product.getPrice(tmpInvtID, 'listprice');
        if (parseFloat(price.toString()) > parseFloat(listPrice.toString())) {
            document.getElementById(`currentPrice${elementIndex}`).innerHTML = `<span class="salePrice">${toUSD(price)}</span>`;
        } else {
            if (price !== 0 && listPrice !== 0 && price !== listPrice) {
                document.getElementById(`currentPrice${elementIndex}`).innerHTML = `<span aria-hidden="false" class="only-readers">Regular price</span><strike>${toUSD(listPrice)}</strike><span aria-hidden="false" class="only-readers">Sale price</span><span class="salePrice">${toUSD(price)}</span>`;
            } else {
                if (price !== 0) {
                    document.getElementById(`currentPrice${elementIndex}`).innerHTML = toUSD(price);
                }
            }
        }
        classOptions.itemProps[tmpItemID].ListPrice = listPrice;
        classOptions.itemProps[tmpItemID].Price = price;
        if (addOnProductID) {
            HAH.product.checkAddOnStock(tmpItemID, elementIndex, addOnProductID, addOnElementIndex, Instock);
            tmpInvtID = HAH.product.getProductID(addOnProductID, addOnElementIndex);
            addOnPrice = HAH.product.getPrice(tmpInvtID);
            addOnListPrice = HAH.product.getPrice(tmpInvtID, 'listprice');
            if (parseFloat(addOnPrice.toString()) > parseFloat(addOnListPrice.toString())) {
                document.getElementById('addOnPrice').innerHTML = toUSD(addOnPrice);
            } else {
                if (addOnPrice !== 0 && addOnListPrice !== 0 && addOnPrice !== addOnListPrice) {
                    document.getElementById('addOnPrice').innerHTML = `<span aria-hidden="false" class="only-readers">Regular price</span><strike>${toUSD(addOnListPrice)}</strike><span aria-hidden="false" class="only-readers">Sale price</span> ${toUSD(addOnPrice)}`;
                } else {
                    if (addOnPrice !== 0) {
                        document.getElementById('addOnPrice').innerHTML = toUSD(addOnPrice);
                    } else {
                        try {
                            document.getElementById('addOnPrice').innerHTML = (<HTMLInputElement>document.getElementById('addOnpriceRange')).value;
                        } catch (e) { }
                    }
                }
            }
            classOptions.itemProps[tmpItemID].addOn.ListPrice = addOnListPrice;
            classOptions.itemProps[tmpItemID].addOn.Price = addOnPrice;
        }
    } else {
        groundShipIDs = (<HTMLFormElement>document.getElementById('OCForm1')).groundShipIDs.value.split(',');
        InstockOverride = false;
        if (groundShipIDs) {
            for (let j = 0; j < groundShipIDs.length; j++) {
                if (groundShipIDs[j] === tmpItemID) {
                    InstockOverride = true;
                    j = groundShipIDs.length;
                }
            }
        }
        stockMessage = HAH.product.doGetStockMessage(tmpItemID, 0, InstockOverride);
        if (stockMessage !== '') {
            try {
                document.getElementById('SPANstock0').innerHTML = stockMessage;
            } catch (e) {
            }
        }
        tmpInvtID = HAH.product.getProductID(tmpItemID, 0);
        price = HAH.product.getPrice(tmpInvtID);
        listPrice = HAH.product.getPrice(tmpInvtID, 'listprice');
        if (parseFloat(price.toString()) > parseFloat(listPrice.toString())) {
            document.getElementById('currentPrice0').innerHTML = `<span class="salePrice">${toUSD(price)}</span>`;
        } else {
            if (price !== 0 && listPrice !== 0 && price !== listPrice) {
                document.getElementById('currentPrice0').innerHTML = `<span aria-hidden="false" class="only-readers">Regular price</span><strike>${toUSD(listPrice)}</strike><span aria-hidden="false" class="only-readers">Sale price</span><span class="salePrice">${toUSD(price)}</span>`;
            } else {
                if (price !== 0) {
                    document.getElementById('currentPrice0').innerHTML = toUSD(price);
                }
            }
        }
        classOptions.itemProps[tmpItemID].ListPrice = listPrice;
        classOptions.itemProps[tmpItemID].Price = price;
    }
}